import React from 'react';
export const ReviewsSection = () => {
  return <section id="reviews" className="w-full py-12 bg-green-900/10" data-id="element-242">
      <div className="container mx-auto px-4" data-id="element-243">
        <div className="flex flex-col md:flex-row gap-8 mb-10" data-id="element-244">
          <div className="w-full md:w-1/2" data-id="element-245">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2CUrGaZxuRPYTSizj8xSfp/Design_sem_nome_%2872%29.png" alt="Dr. Sarah Chan sitting with her golden retriever Max and a jar of Snouty & Co. Daily Foundation Chew" className="w-full h-full object-cover rounded-lg shadow-md" data-id="element-246" />
          </div>
          <div className="w-full md:w-1/2" data-id="element-247">
            <div className="bg-amber-50 p-8 rounded-lg shadow-md h-full relative overflow-hidden" data-id="element-248">
              {/* Paw print watermark */}
              <div className="absolute right-0 bottom-0 opacity-5 transform rotate-12" data-id="element-249">
                <svg width="200" height="200" viewBox="0 0 100 100" fill="currentColor" className="text-green-900" data-id="element-250">
                  <path d="M48.1,17.1c-5.6,0.8-9.3,5.9-8.5,11.5c0.8,5.6,5.9,9.3,11.5,8.5c5.6-0.8,9.3-5.9,8.5-11.5C58.8,20,53.7,16.3,48.1,17.1z" data-id="element-251" />
                  <path d="M27.5,29.6c-5.2,2.1-7.7,8-5.6,13.2c2.1,5.2,8,7.7,13.2,5.6c5.2-2.1,7.7-8,5.6-13.2C38.6,30,32.7,27.5,27.5,29.6z" data-id="element-252" />
                  <path d="M72.5,29.6c-5.2-2.1-11.1,0.4-13.2,5.6c-2.1,5.2,0.4,11.1,5.6,13.2c5.2,2.1,11.1-0.4,13.2-5.6C80.2,37.6,77.7,31.7,72.5,29.6z" data-id="element-253" />
                  <path d="M36.8,60.4c-4-4-10.5-4-14.5,0c-4,4-4,10.5,0,14.5c4,4,10.5,4,14.5,0C40.8,71,40.8,64.5,36.8,60.4z" data-id="element-254" />
                  <path d="M77.7,60.4c-4-4-10.5-4-14.5,0c-4,4-4,10.5,0,14.5c4,4,10.5,4,14.5,0C81.7,71,81.7,64.5,77.7,60.4z" data-id="element-255" />
                  <path d="M58.5,64.5c-7.1-7.1-18.6-7.1-25.7,0L21.4,75.9c-7.1,7.1-7.1,18.6,0,25.7c7.1,7.1,18.6,7.1,25.7,0l11.4-11.4C65.6,83.1,65.6,71.6,58.5,64.5z" data-id="element-256" />
                </svg>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-green-900 mb-4" data-id="element-257">
                From a Guardian, For a Guardian
              </h2>
              <div className="mb-4" data-id="element-258">
                <h3 className="text-xl font-bold text-green-900" data-id="element-259">
                  Dr. Sarah Chan, DVM, PhD
                </h3>
                <p className="text-green-900/70" data-id="element-260">
                  Veterinary Nutritionist & Founder | Mother to Max, a
                  9-year-old Golden Retriever
                </p>
              </div>
              <p className="text-green-900/80 mb-6" data-id="element-261">
                "The Daily Foundation Chew was born out of necessity. When Max
                began showing signs of digestive issues and joint pain at just 5
                years old, I was devastated. As a veterinary nutritionist, I
                knew the conventional options weren't addressing the root cause.
              </p>
              <p className="text-green-900/80 mb-6" data-id="element-262">
                After two years of research and formulation, I created what
                would become The Daily Foundation Chew. Within weeks, Max's
                energy returned, his coat regained its shine, and his digestive
                issues disappeared. I knew I had to share this with other pet
                parents facing the same struggle.
              </p>
              <p className="text-green-900/80 mb-6" data-id="element-263">
                This isn't just another supplement—it's the solution I created
                for my own beloved companion, formulated with the scientific
                rigor of a veterinary nutritionist and the love of a devoted pet
                parent."
              </p>
              <div className="flex justify-center mt-6" data-id="element-264">
                <a href="#testimonials" className="bg-yellow-700 hover:bg-yellow-800 text-amber-50 font-bold py-3 px-8 rounded-full text-lg shadow-md transition duration-300 inline-block" data-id="element-265">
                  LEARN ABOUT OUR JOURNEY
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-8 mt-12" data-id="element-266">
          <div className="w-full" data-id="element-267">
            <p className="text-green-900/80 mb-6 text-center" data-id="element-268">
              As Featured In:
            </p>
            <div className="max-w-4xl mx-auto mb-8" data-id="element-269">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rR8GdBppvNrWuXYbdRNZhw/Design_sem_nome_%2825%29.png" alt="As Seen On Sponsored Content - ABC, CBS, Forbes, NBC" className="w-full rounded-lg shadow-md" data-id="element-270" />
            </div>
            <div className="flex justify-center" data-id="element-271">
              <a href="#testimonials" className="bg-yellow-700 hover:bg-yellow-800 text-amber-50 font-bold py-3 px-8 rounded-full text-lg shadow-md transition duration-300 inline-block" data-id="element-272">
                LEARN MORE
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};